/** Single source of truth for Numerology shell branding and home path. */
export const NUMEROLOGY_HOME_PATH = '/numerology';

export const NUMEROLOGY_BRAND_LOGO_URL =
  'https://d1yei2z3i6k35z.cloudfront.net/15470577/6994a06c0a4b8_astral-moon-magic-logo-vector.png';

/** Exact visible title (hyphen as specified). */
export const NUMEROLOGY_BRAND_TITLE = 'Astral Moon Magic - Numerology Master Course';
